export default __webpack_public_path__ + "static/media/ManufacturingIndustries_icon.237fc20f.svg";